import { useRef } from "react";
import { useDispatch } from "react-redux";
import { setSelectedQueryModal } from "redux/SingleDataset/actions";

import {
  CustomMetadata,
  CustomMetadataValue,
  CustomMetadataOperators,
} from "types";

import { formatUnderscoreWithSpace } from "helpers/utility/formatters";
import {
  createAndUpdateCustomMetadataFilter,
  getExistingCustomMetadataQuery,
} from "helpers/utility/vqlHelpers";
import useVqlParams from "hooks/useVqlParams";

interface UseCustomMetadataModalProps {
  field: CustomMetadata;
  editQueryId?: string;
}

export function useCustomMetadataModal({
  field,
  editQueryId,
}: UseCustomMetadataModalProps) {
  const dispatch = useDispatch();
  const { vqlQueries, addVqlQuery, findVqlQuery, updateVqlQuery } =
    useVqlParams();
  const modalRef = useRef<HTMLDivElement>(null);

  const oldQuery = editQueryId
    ? findVqlQuery(editQueryId, "custom_metadata")
    : null;

  const handleSubmission = (
    operator: CustomMetadataOperators,
    value: CustomMetadataValue,
  ) => {
    const existingQuery = getExistingCustomMetadataQuery(
      vqlQueries,
      field.field_id,
      operator as CustomMetadataOperators,
    );

    const vqlQuery = createAndUpdateCustomMetadataFilter(
      operator,
      value,
      field,
      editQueryId ? editQueryId : existingQuery?.id,
    );
    if (existingQuery || editQueryId) {
      updateVqlQuery(vqlQuery);
    } else {
      addVqlQuery(vqlQuery);
    }

    dispatch(setSelectedQueryModal(null));
  };

  const fieldName = formatUnderscoreWithSpace(field.field_name);

  return {
    modalRef,
    oldQuery,
    handleSubmission,
    fieldName,
  };
}
